import { DefaultLayout as Layout } from '../../../layouts/Default/DefaultLayout';
import { MembershipTypeSearch } from '../MembershipTypeSearch/MembershipTypeSearch';

export const MembershipTypeManagerPage = () => {
  return (
    <Layout>
      <h1 id="primaryPageTitle" className="d-inline">
        Membership Types Maintenance
      </h1>
      <MembershipTypeSearch />
    </Layout>
  );
};
